/**
 * Created by Ivan on 06/05/2017.
 */
import Vue from 'vue';
import Router from 'vue-router';
import Home from '../modules/home/Home.vue';
import Contact from '../modules/contact/Contact.vue';
import Site from '../modules/site/Site.vue';
import Rooms from '../modules/rooms/Rooms.vue';
import Restaurants from '../modules/restaurants/RestaurantList.vue';
import Blog from '../modules/blog/Blog.vue';
import BookOnline from '../modules/bookOnline/BookOnline.vue';
import SingleRoom from '../modules/singleRoom/single.vue';
import SingleRestaurant from '../modules/restaurants/Single.vue';

Vue.use(Router);

export default new Router({
    mode : 'history',
    routes : [
        {
            path : '/',
            name : 'Home',
            component : Home
        },
        {
            path : '/site',
            name : 'Site',
            component : Site,
            children : [
                {
                    path : 'contact',
                    component : Contact
                },
                {
                    path : 'rooms',
                    component : Rooms,
                    name : 'Rooms',
                },
                {
                    path : 'restaurants',
                    component : Restaurants,
                    name : 'Restaurants',
                },
                {
                    path : 'restaurant/:id',
                    component : SingleRestaurant,
                    name : 'Single restaurant',
                },
                {
                    path : 'blog',
                    component : Blog
                },
                {
                    path : 'book',
                    component : BookOnline
                },
                {
                    path : 'room/:id',
                    component : SingleRoom,
                    name : 'SingleRoom'
                }
            ]
        },
    ]
});


// WEBPACK FOOTER //
// ./src/router/router.js